/**
 * Resolves an error object to a readable string message.
 * Handles HttpErrorResponse, raw errors, and various response formats.
 */
export function resolveErrorMessage(error: any): string {
  if (error === null || error === undefined) {
    return '';
  }
  if (typeof error === 'string') {
    return error;
  }
  // Check error.error first (nested error payload from API)
  if (error.error !== null && error.error !== undefined) {
    if (typeof error.error === 'string') {
      return error.error;
    }
    if (error.error.message) {
      return error.error.message;
    }
  }
  // Fall back to top-level message field
  if (error.message) {
    return error.message;
  }
  return 'Ocurrió un error inesperado.';
}
